import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function MoviStack() {
  return (
    <div className="portfolio-movistack">
      <div className="portfolio-description">
        <p>
          A website to download movies made in{" "}
          <span style={{ color: "rgba(0, 240, 87, 0.92)" }}>2018</span>.
        </p>
        <p>
          It uses TMDB API for getting movie details like images, title, imdb
          rating.
        </p>
        <p>Download links created using web crawlers made with python.</p>
        <p>It uses Disqus commenting system.</p>
        <p>
          <a
            href="https://gitlab.com/amitad16/movi-stack"
            target="_blank"
            rel="noreferrer noopener"
            style={{ color: "rgba(0, 240, 87, 0.92)" }}
          >
            Check it out on <i className="fa fa-github"></i>
          </a>
        </p>
      </div>
      <div className="row">
        <div>
          <LazyLoadImage
            src="images/portfolio/movistack/1.gif"
            alt="MoviStack website preview"
            style={{ width: "100%" }}
            effect="blur"
          />
        </div>
        <div>
          <LazyLoadImage
            src="images/portfolio/movistack/3.gif"
            alt="MoviStack website preview"
            style={{ width: "100%" }}
            effect="blur"
          />
        </div>
        <div>
          <LazyLoadImage
            src="images/portfolio/movistack/2.gif"
            alt="MoviStack website preview"
            style={{ width: "100%" }}
            effect="blur"
          />
        </div>
      </div>
    </div>
  );
}

export default MoviStack;
